import getScenarioStore from '../store/getScenarioStore';
import { SearchScenarioId } from 'owa-search-next-common';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('onSuggestionsCalloutPositioned', (scenarioId: SearchScenarioId) => {
    getScenarioStore(scenarioId).isSuggestionsCalloutClickable = false;
});
